import { render, staticRenderFns } from "./memoryTip.vue?vue&type=template&id=6970711a&"
import script from "./memoryTip.vue?vue&type=script&lang=js&"
export * from "./memoryTip.vue?vue&type=script&lang=js&"
import style0 from "./memoryTip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports